// extracted by extract-css-chunks-webpack-plugin
module.exports = {"listItemLink":"styles__listItemLink__8N7mN","caption":"styles__caption__2Ew0M"};